import { Routes } from '@angular/router';
import { PAGE_TITLE_SUFFIX } from '../../app.constants';

import { UserRouteAccessService } from '../../shared';
import { ErrorComponent } from './error.component';

export const errorRoute: Routes = [
  {
    path: 'error',
    component: ErrorComponent,
    data: {
      needAuthentication: false,
      pageTitle: `Erreur 404${PAGE_TITLE_SUFFIX}`
    },
    canActivate: [UserRouteAccessService]
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/error/error.route.ts